import ConfiguredCar from './types/configured-car';

export default class SaveForLater {
    constructor(parent) {
        this.MAX_ITEMS = 20;

        this.parent = parent;
        this.myAccount = parent.myAccount;
        this.myAccount2 = parent.myAccount2;
        this.router = parent.router;
        this.saved = [];
        this.removed = [];
        this.saved = this.parse('save-for-later');
        this.removed = this.parse('remove-for-later'); 
        this.bind();
    }

    bind() {
        if(!this.myAccount2?.isLoggedIn()) {
            this.myAccount2?.addEventListener('login', () => this.sync());
        }
    }

    get(id) {
        return this.saved.find((item) => id === item.data.id);
    }
    
    create(type, from, item) {
        if (type === 'HondaCarConfiguratorOffer') { return new ConfiguredCar(this, from, item); }
        return null;
    }

    parse(key){
        const json = localStorage.getItem(key);
        const items = json ? JSON.parse(json) : [];
        return items.map((item) => this.create(item?.type, 'localStorage', item)).filter((item) => item);
    }

    save(item) {
        if(item) {
            this.saved.push(item);
            this.persist();
            this.parent.update();
            this.limit();
            this.sync();
        }
    }

    persist() {
        const saved = this.saved.map((item) => item.data);
        const removed = this.removed.map(item => item.data);
        localStorage.setItem('save-for-later', JSON.stringify(saved));
        localStorage.setItem('remove-for-later', JSON.stringify(removed));
    }

    remove(item) {
        if(item) {
            this.saved = this.saved.filter((i) => i.data.id !== item.data.id);
            this.removed.push(item);
            this.persist();
            this.parent.update();
            this.sync();
        }
    }

    async sync() {
        if(this.myAccount2) {
            this.syncMyAccount2();
        } else if(this.myAccount) {
            this.syncMyAccount();
        } else {
            this.removed = [];
            this.persist();
        }
    }

    limit() {
        this.saved
            .sort((i1, i2) => new Date(i1.data.dateCreated) - new Date(i2.data.dateCreated))
            .reverse()
            .slice(this.MAX_ITEMS)
            .forEach((item) => this.remove(item));
    }

    async syncMyAccount2() {
        if(this.myAccount2?.isLoggedIn()) {
            const updated = {
                local: false,
                remote: false,
            };

            const result = await this.myAccount2.client.getSavedItems();
            if(result) {
                const local = this.saved.map((r) => r.data.id).sort();
                const remote = result ? result.map((r) => r.id).sort() : [];
                
                if(!_.isEqual(local, remote)) {
                    //Sync Down
                    result.forEach((r) => {
                        const matches = [...this.saved, ...this.removed].some((i) => r.id === i.data.id);
                        if(!matches) {
                            const item = this.create(r.type, 'myAccount2', r);
                            if(item) {
                                this.saved.push(item);
                                updated.local = true;
                            }
                        }
                    });

                    const isvID = window.HONDA.MyAccount2.id();

                    // Add ISV ID to any item which doesn't have one
                    this.saved.forEach((item) => {
                        if (!item.data.isvID) {
                            item.data.isvID = isvID;
                        }
                    });

                    // Remove any items which have an ISV ID that doesn't match the current logged-in user
                    this.saved = this.saved.filter((item) => item.data.isvID === isvID);

                    //Sync Up
                    const upload = this.saved.map((item) => item.data);
                    await this.myAccount2.client.postSavedItems(JSON.stringify(upload));
                    window.HONDA.MyAccount2.client.flushCache('saved-items');
                    updated.remote = true;

                    this.persist();
                    this.parent.update(updated);
                }
            }
        }
    }

    async syncMyAccount() {
        if (this.myAccount?.isLoggedIn()) {
            const remote = [];
            const updated = {
                local: false,
                remote: false,
            };

            const result = await this.myAccount.query('offers', { fetchPolicy: "no-cache" });
            const offers = result?.data?.me?.offers?.filter((o) => o.type === 'HondaCarConfiguratorOffer');

            // Sync Down
            offers?.forEach((o) => {
                const matches = [...this.saved, ...this.removed].some((i) => o.id === i.data.id);
                if (!matches) {
                    const item = this.create(o.type, 'myAccount', o);
                    if(item) {
                        this.saved.push(item);
                        updated.local = true;
                    }
                }
            });

            // Sync Up
            this.saved.forEach((i) => {
                const matches = offers.some((o) => o.id === i.data.id);
                const action = i.data.id === this.myAccountActionId();
                if (!i.data.synced && !matches && !action) {
                    i.data.synced = true;
                    remote.push(i.toMyAccount());
                } else if(action) {
                    i.data.synced = true;
                }
            });

            // Remove Down
            this.saved = this.saved.filter((i) => {
                const matches = offers.some((o) => o.id === i.data.id);
                const remove = i.data.synced && !matches;
                if(remove) { updated.local = true; }
                return !remove;
            });

            // Remove Up
            offers?.forEach((o) => {
                const item = this.removed.find((i) => o.id == i.data.id);
                if(item){                    
                    remote.push(item.removeMyAccount());
                }
            });
            this.removed = [];

            // Wait for network calls to finish
            if(remote.length > 0) {
                const results = await Promise.all(remote);
                updated.remote = results.some((r) => r.success);
            }

            this.persist();
            this.parent.update(updated);
        } 
    }

    myAccountActionId() {
        const sessionContext = localStorage.getItem('sessionContext');
        try {
            const obj = JSON.parse(sessionContext) || {};
            return obj?.action?.attrs?.id     
        } catch(err) {
            return '';
        }
    }
}